import { render } from "./Breadcrumbs.vue?vue&type=template&id=24f5711e&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=24f5711e&scoped=true&lang=css"

import exportComponent from "/home/blessed_fms/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f5711e"]])

export default __exports__